module.exports = __webpack_public_path__ + "assets/img/317cc6351719d971b493806e54dee64d.png";